<template>
    <div>
        <v-container fluid>
            <v-row class="p-3">
                <v-col
                        v-for="(image,index) in img"
                        :key="image.id"
                        cols="12"
                        class="mx-auto my-2 card boxStyle"
                        md="2"
                        :data-img="image.id"
                >
                    <v-radio-group class="p-0 m-0" v-model="selectedImage">
                        <v-radio
                                color="indigo"
                                :value="image.value"
                        ></v-radio>
                    </v-radio-group>
                    <img :src="image.full_path"  class="img-fluid"
                         :key="image.id">
                    <p class="text-center my-0">{{image.name}}</p>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
    name: "folderMat",
    data() {
        return {
            selectedImage: [],
            img: [
                {id:'1',name:'چرمی',value:'leather',full_path:require('../../../../../../public/media/site/material/folder/فولدر-چرمی.png')},
                {id:'2',name:'کتان',value:'cotton',full_path:require('../../../../../../public/media/site/material/folder/فولدر-کتان.png')},
                {id:'3',name:'تحریر',value:'writing',full_path:require('../../../../../../public/media/site/material/folder/فولدر تحریر.jpg')},
            ],
            count: 1,
        }
    },
    watch:{
        selectedImage() {
            this.$emit('persianName',this.img.find((x)=>x.value === this.selectedImage).name,"folderMat")
            this.$emit('input', this.selectedImage)
        }
    }
}
</script>

<style scoped>

</style>